import { useEffect, useState } from 'react';
import { useDispatch,useSelector } from 'react-redux';
import { updateState, selectMPSTopicFile } from '../features/counter/counterSlice';
import { useHistory } from 'react-router-dom';
import { removeSpecialCharacters } from '../utils';


const useTOC = () => {
  const history = useHistory();
  const useTOCState = (search) => {
    const dispatch = useDispatch();
    const [toc, setToc] = useState('');
    const [tocIdHTML, setTocIdHTML] = useState('');
    const [ditapath, setDitapath] = useState('');
    const mpstopicfile = useSelector(selectMPSTopicFile);
    
    useEffect(() => {
      let tocID;
      const params = new URLSearchParams(search);
  
      if(search.indexOf("bookTitle")>-1) {
        tocID = params.get('bookTitle');
      } else {
        try {
          const guidelinePage = removeSpecialCharacters(params.get('guidelinePage'));
          tocID = mpstopicfile[guidelinePage.replace(/ /g,"_")]?.text || " ";
        } catch (error) {
          console.error(error);
        }

      }
      if (tocID) {
        if (tocID.includes('_')) {
          tocID = tocID.replace(/_+/g, ' ').trim().replace(/\s+/g, ' ');
        }

        dispatch(updateState({ tocId: tocID }));
        setDitapath(tocID.replace(/ /g,"_"));
        setTocIdHTML(tocID);
        document.title = `${tocID} - Therapeutic Guidelines`;
      }
    }, [search])

    return { toc, tocIdHTML, ditapath }
  }

  return { useTOCState }
};

export default useTOC;